import { render, staticRenderFns } from "./BankruptcyModal.vue?vue&type=template&id=49486ff3"
import script from "./BankruptcyModal.vue?vue&type=script&lang=js"
export * from "./BankruptcyModal.vue?vue&type=script&lang=js"
import style0 from "./BankruptcyModal.vue?vue&type=style&index=0&id=49486ff3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports